import { Injectable, inject } from '@angular/core';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { PromotionContestCardComponent } from './home-cards/promotion-contest-card/promotion-contest-card.component';


@Injectable({ providedIn: 'root' })
export class PlsCardService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private _unsub$ = new Subject<void>();

  constructor() {
    this._serviceInventory
      .getService('promotion_contest')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          switch (service.state) {
            case ServiceState.INITIAL:
              this.registerPromotionContestCard();
              break;
            default:
              this.removePromotionContestCard();
              break;
          }
        }),
        takeUntil(this._unsub$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._unsub$.next();
  }

  private registerPromotionContestCard() {
    this._homeFeedService.registerHomeFeedCard({
      key: 'promotion-contest',
      component: 'PromotionContestCardComponent',
      componentRef: PromotionContestCardComponent,
      section: HomeFeedSection.PROMOTION,
      order: 1,
    });
  }

  private removePromotionContestCard() {
    this._homeFeedService.removeHomeFeedCard('promotion-contest', HomeFeedSection.PROMOTION);
  }
}
